import React, { useEffect, useState} from "react";
import translate from '../../../i18n/translate';
import "./CultureCentre.scss";
import allActions from '../../../redux/actions';
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import { useNavigate } from 'react-router-dom';
import Loader from "../../shared/Loader/Loader";
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from "@material-ui/core";

const CultureCentre: React.FC = () => {

    const useStyles = makeStyles((theme) => ({
        root: {
            "& .MuiOutlinedInput-root": {
                borderRadius: '0'
            }
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 250,
            borderRadius: 0
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
            borderRadius: 0
        },
    }));

    const [cultureCentreFeatureEnabled, setCultureCentreFeatureEnabled] = useState(false);
    const [cultureCentreErrorEnabled, setCultureCentreErrorEnabled] = useState(false);
    const [display, setDisplay] = useState<number>(-1);
    const [loaderFlag, setLoaderFlag] = useState<boolean>(true);
    const navigate = useNavigate();
    const classes = useStyles();
    const dispatch = useDispatch();
    const allInfo = useSelector((state: any) => state);

    useEffect(() => {
        dispatch(allActions.cultureCentreAction.getCountriesList());        
    }, []);

    useEffect(() => {
        if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
            if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28)) === "1") {
                setCultureCentreFeatureEnabled(true);
                setCultureCentreErrorEnabled(false);
            } else {
                setCultureCentreFeatureEnabled(false);
                setCultureCentreErrorEnabled(true);
            }
        }
        if(!!!allInfo.cultureCentreCountries.isLoading && !!!allInfo.cultureCentreCountries.isFailed && allInfo.cultureCentreCountries.data) {
            setTimeout(() => setLoaderFlag(false), 600);
        }
    }, [allInfo.peopleInformation, allInfo.cultureCentreCountries]);

    const handleChangeValue = (countryCode: any) => {
        dispatch(allActions.commonActions.setSelectedCountry(countryCode));
        navigate(`/culturecenter/${countryCode.toLowerCase()}`);
    };

    return (
        <span className="culture-Notes-Container">
            {cultureCentreFeatureEnabled && allInfo.cultureCentreCountries.data &&
                <div className="culture_Notes_Container">
                    <div className="culture_child_header">
                        <div className="CN-Title">
                            <h3 className="culture_header_text">
                                {translate("feature_culture_centre_title")}
                            </h3>
                        </div>
                    </div>
                    <div className="culture-notes-layout">
                        <div className="culture-notes-body header-wrapper">
                            <p>{translate("feature_cultureCentre_desc")}</p>                        
                        </div>
                        <div className="disclaimer_layout">
                            <h6 className="disclaimer_title">{translate("culurecenter_disclaimer_title")}:</h6>
                            <p className="disclaimer_desc">{translate("culturecenter_disclaimer")}</p>
                            <h5 className="region_style">{translate("SAR")}</h5>
                        </div>
                        <div className="country-whole-wrap">
                            {allInfo.cultureCentreCountries.data.map(((element: any, index: number) => {
                                return (
                                    <div className={`country-individual-wrap ${(display === index) ? "hover-color" : ""}`}
                                        key={index} 
                                        onClick={() => handleChangeValue(element.code)}
                                        onMouseEnter={() => { setDisplay(index)}}
                                        onMouseLeave={() => { setDisplay(-1)}}
                                        >
                                            <img className="culcen-image-wrap" src={element.flag} alt=""/>
                                            <span>{element.name}</span>
                                    </div>
                                )
                            }))}
                        </div>
                    </div>                  
                </div>
            }   
            {cultureCentreErrorEnabled && (
                <div className="culture-Notes-Errorpage">      
                    <ErrorPage status={401} />
                </div>
            )}
            <Loader showLoader={loaderFlag} /> 
       </span>
    );
}

export default CultureCentre;